import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import * as constatnts from '../../Constatnts'
import { isNullOrUndefined } from 'util';
import Loader from '../Loader'
import ReactHtmlParser from 'react-html-parser';


class InvoiceDetailList1 extends Component {
    constructor() {
        super()
        this.state = {
            taxes: [{ "name": "CGST", "perc": "CGST%" }, { "name": "SGST", "perc": "SGST%" }, { "name": "IGST", "perc": "IGST%" }, { "name": "CESS", "perc": "CESS%" }],
            invoices: [],
            stores: [],
            storeList: [],
            searchText: '',
            searchTransactionNo: '',
            searchTransactiontype: '',
            searchTransactionFromDate: new Date().toISOString().split('T')[0],
            searchTransactionToDate: new Date().toISOString().split('T')[0],
            searchCustomerDetail: '',
            searchProductDetail: '',
            searchDiscount: '',
            searchTaxableAmount: '',
            searchTaxSummary: '',
            activePage: 1,
            itemsCountPerPage: 20,
            totalItemsCount: 0,
            recordFrom: 0,
            title: '',
            paginationStatus: 'No records to display',
            exportCalled: false,
            loading: true,
            customField1DisplayName:'Custom Field 1',
            customField2DisplayName:'Custom Field 2',
            customField3DisplayName:'Custom Field 3',
            customField4DisplayName:'Custom Field 4',
            customField5DisplayName:'Custom Field 5',
            customField6DisplayName:'Custom Field 6',
        }

        this.onClearSearch = this.onClearSearch.bind(this)
        this.onSearchClick = this.onSearchClick.bind(this)
        // this.handlePageChange = this.handlePageChange.bind(this)
        // this.showPaginationStatus = this.showPaginationStatus.bind(this)
        this.handleKeyPress = this.handleKeyPress.bind(this)
        this.onExportClick = this.onExportClick.bind(this)
        this.onStoreChange = this.onStoreChange.bind(this)
    }

    componentDidMount() {
        this.setState({ storeID: this.props.user.store.key })
        let storeList = []
        storeList.push({ key: this.props.user.store.key })

        this.props.getUserStores(this.props.user.user.RegistrationID, "").then((stores) => {                
            this.setState({ stores: stores })
        });
    this.setState({ storeList: storeList, storeID: this.props.user.store.key });

        this.props.config.CustomFields.map((customField) => {
            if (customField.ModuleName === 'Customer')
            {
                let customField1DisplayName = customField.CustomField1Name.trim() === '' ? 'Custom Field 1' : customField.CustomField1Name.trim()
                let customField2DisplayName = customField.CustomField2Name.trim() === '' ? 'Custom Field 2' : customField.CustomField2Name.trim()
                let customField3DisplayName = customField.CustomField3Name.trim() === '' ? 'Custom Field 3' : customField.CustomField3Name.trim()
                let customField4DisplayName = customField.CustomField4Name.trim() === '' ? 'Custom Field 4' : customField.CustomField4Name.trim()
                let customField5DisplayName = customField.CustomField5Name.trim() === '' ? 'Custom Field 5' : customField.CustomField5Name.trim()
                let customField6DisplayName = customField.CustomField6Name.trim() === '' ? 'Custom Field 6' : customField.CustomField6Name.trim()
                this.setState({
                    customField1DisplayName:customField1DisplayName,
                    customField2DisplayName:customField2DisplayName,
                    customField3DisplayName:customField3DisplayName,
                    customField4DisplayName:customField4DisplayName,
                    customField5DisplayName:customField5DisplayName,
                    customField6DisplayName:customField6DisplayName
                })
            }
        })

        this.loadInvoiceDetailReport(storeList,
            this.state.recordFrom,
            this.state.searchTransactionNo,
            this.state.searchTransactiontype,
            this.state.searchTransactionFromDate,
            this.state.searchTransactionToDate,
            this.state.searchCustomerDetail,
            this.state.searchProductDetail,
            this.state.searchDiscount,
            this.state.searchTaxableAmount,
            this.state.searchTaxSummary,


        )
    }

    loadInvoiceDetailReport(storeList, from, searchTransactionNo, searchTransactiontype,
        searchTransactionFromDate, searchTransactionToDate,
        searchCustomerDetail, searchProductDetail, searchDiscount, searchTaxableAmount,
        searchTaxSummary) {

        this.setState({ loading: true })
     
        this.props.getInvoiceDetailReport(this.props.user.user.RegistrationID, storeList, from, this.state.itemsCountPerPage,
            searchTransactionNo, searchTransactiontype,
            searchTransactionFromDate, searchTransactionToDate,
            searchCustomerDetail, searchProductDetail, searchDiscount, searchTaxableAmount,
            searchTaxSummary)
            .then((result) => {
     
                let invoices = []
                
                for (let index = 0; index < result.searchResult.length; index++) {
                    const data = result.searchResult[index];

                    let invoice = {
                        "Store Name ": data.StoreName,
                        "Cash Register": data.CashRegisterName,
                        "Customer Code": data.CustomerCode,
                        "Customer Name": data.CustomerName,
                        "Customer Mobile No.": data.CustomerPhoneNo
                    }
                        invoice[this.state.customField1DisplayName] = ""
                        invoice[this.state.customField2DisplayName] = ""
                        invoice[this.state.customField3DisplayName] = ""
                        invoice[this.state.customField4DisplayName] = ""
                        invoice[this.state.customField5DisplayName] = ""
                        invoice[this.state.customField6DisplayName] = ""
                       
                        invoice[this.state.customField1DisplayName] = data.hasOwnProperty('CustomerCustomField1') ? data.CustomerCustomField1 : ""
                        invoice[this.state.customField2DisplayName] = data.hasOwnProperty('CustomerCustomField2') ?  data.CustomerCustomField2 : ""
                        invoice[this.state.customField3DisplayName] = data.hasOwnProperty('CustomerCustomField3') ? data.CustomerCustomField3 : ""
                        invoice[this.state.customField4DisplayName] = data.hasOwnProperty('CustomerCustomField4') ? data.CustomerCustomField4 :""
                        invoice[this.state.customField5DisplayName] = data.hasOwnProperty('CustomerCustomField5') ? data.CustomerCustomField5 : ""
                        invoice[this.state.customField6DisplayName] = data.hasOwnProperty('CustomerCustomField6') ? data.CustomerCustomField6 : ""
                        
                        invoice["Transaction No"]= data.TransactionNo
                        invoice["Transaction Type"] = data.TransactionType
                        invoice["Transaction Date"] = (new Date(data.TransactionDate).toISOString().split('T')[0])
                        invoice.Cancelled = "No"
                        if (data.CancellationReason) {
                            invoice.Cancelled = "Yes"
                        }
                        invoice["Type"] = data.ProductType
                        invoice["HSNSAC Code"] =data.HSNSACCode
                        invoice["Item Code"] = data.SKU
                        invoice["Item Name"] = data.ProductName
                        invoice["MRP"] = data.MRP
                        invoice["RetailPrice"] = data.Amount
                        invoice["Qty"] = data.Qty
                        invoice["Tax Inclusive"] = data.TaxInclusive
                        invoice["Taxble Amount"] = data.TaxableAmount                    
                    
                    for (let index = 0; index < this.state.taxes.length; index++) {
                        invoice[this.state.taxes[index].name] = 0
                        invoice[this.state.taxes[index].perc] = ""
                    }
                    if (data.TaxComponentAmount) {
                        data.TaxComponentAmount.map((tax) => {
                            invoice[tax.TaxName] = tax.TaxAmount
                            invoice[tax.TaxName + '%'] = tax.TaxPercentage
                        })
                    }
                    invoice["Sub Total"] = data.SubTotal
                    invoice["Total Tax"] = data.TotalTax
                    invoice["Discount"] = data.DiscountAmount
                    invoice["Grand Total"] = data.Amount

                    invoices.push(invoice);
                }
                
                var col = [];
                for (var i = 0; i < invoices.length; i++) {
                    for (var key in invoices[i]) {
                        if (col.indexOf(key) === -1) {
                            col.push(key);
                        }
                    }
                }

                var result = "<table class='table table-bordered'><thead><tr>";
                for (var i = 0; i < col.length; i++) {
                    result += "<th>";
                    result += col[i];
                    result += "</th>";
                }
                result += "</tr></thead>";

                // ADD JSON DATA TO THE TABLE AS ROWS.
                result += "<tbody>";
                for (var i = 0; i < invoices.length; i++) {
                    result += "<tr>";
                    for (var j = 0; j < col.length; j++) {
                        result += "<td>";
                        result += invoices[i][col[j]] == undefined ? 0 : invoices[i][col[j]];
                        result += "</td>";
                    }
                    result += "</tr>";
                }
                result += "</tbody>";
                result += "</table>";
                //console.log(result);
                this.setState({ invoices: result, loading: false })
            })
    }

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.onSearchClick()
        }
    }

    onClearSearch() {
        let storeList = []
        storeList.push({ key: this.props.user.store.key});

        this.setState({
            storeList : storeList,
            storeID : this.props.user.store.key, 
            recordFrom: 0, searchTransactionNo: '',
            searchTransactiontype: '',
            searchTransactionFromDate: new Date().toISOString().split('T')[0],
            searchTransactionToDate: new Date().toISOString().split('T')[0],
            searchCustomerDetail: '', searchProductDetail: '', searchDiscount: '', searchTaxableAmount: '',
            searchTaxSummary: ''
        })
        this.loadInvoiceDetailReport(storeList, 0, "", "", this.state.searchTransactionFromDate, this.state.searchTransactionToDate, "", "", "", "", "", "")
    }

    onExportClick() {
        this.setState({ exportCalled: true })
        this.props.getInvoiceDetailReport(this.props.user.user.RegistrationID, this.state.storeList, 0, 10000,
            this.state.searchTransactionNo,
            this.state.searchTransactiontype,
            this.state.searchTransactionFromDate,
            this.state.searchTransactionToDate,
            this.state.searchCustomerDetail,
            this.state.searchProductDetail,
            this.state.searchDiscount,
            this.state.searchTaxableAmount,
            this.state.searchTaxSummary)
            .then((result) => {
                console.log(result.searchResult);
                if (isNullOrUndefined(result.searchResult) || result.searchResult.length === 0) {
                    this.props.getToastr("No Record Found")
                    return
                }
                let invoices = []
                result.searchResult.map((data) => {
                    let invoice = {
                        "Store Name ": data.StoreName,
                        "Cash Register": data.CashRegisterName,
                        "Customer Code": data.CustomerCode,
                        "Customer Name": data.CustomerName,
                        "Customer Mobile No.": data.CustomerPhoneNo
                    }
                    invoice[this.state.customField1DisplayName] = ""
                    invoice[this.state.customField2DisplayName] = ""
                    invoice[this.state.customField3DisplayName] = ""
                    invoice[this.state.customField4DisplayName] = ""
                    invoice[this.state.customField5DisplayName] = ""
                    invoice[this.state.customField6DisplayName] = ""

                    invoice[this.state.customField1DisplayName] = data.hasOwnProperty('CustomerCustomField1') ? data.CustomerCustomField1 : ""
                    invoice[this.state.customField2DisplayName] = data.hasOwnProperty('CustomerCustomField2') ?  data.CustomerCustomField2 : ""
                    invoice[this.state.customField3DisplayName] = data.hasOwnProperty('CustomerCustomField3') ? data.CustomerCustomField3 : ""
                    invoice[this.state.customField4DisplayName] = data.hasOwnProperty('CustomerCustomField4') ? data.CustomerCustomField4 :""
                    invoice[this.state.customField5DisplayName] = data.hasOwnProperty('CustomerCustomField5') ? data.CustomerCustomField5 : ""
                    invoice[this.state.customField6DisplayName] = data.hasOwnProperty('CustomerCustomField6') ? data.CustomerCustomField6 : ""

                    invoice["Transaction No"]= data.TransactionNo
                    invoice["Transaction Type"] = data.TransactionType
                    invoice["Transaction Date"] = (new Date(data.TransactionDate).toISOString().split('T')[0])
                    invoice.Cancelled = "No"
                    if (data.CancellationReason) {
                        invoice.Cancelled = "Yes"
                    }
                    invoice["Type"] = data.ProductType
                    invoice["HSNSAC Code"] =data.HSNSACCode
                    invoice["Item Code"] = data.SKU
                    invoice["Item Name"] = data.ProductName
                    invoice["MRP"] = data.MRP
                    invoice["RetailPrice"] = data.Amount
                    invoice["Qty"] = data.Qty
                    invoice["Tax Inclusive"] = data.TaxInclusive
                    invoice["Taxble Amount"] = data.TaxableAmount

                    for (let index = 0; index < this.state.taxes.length; index++) {
                        invoice[this.state.taxes[index].name] = 0
                        invoice[this.state.taxes[index].perc] = ""
                    }
                    if (data.TaxComponentAmount) {
                        data.TaxComponentAmount.map((tax) => {
                            invoice[tax.TaxName] = tax.TaxAmount
                            invoice[tax.TaxName + '%'] = tax.TaxPercentage
                        })
                    }
                    invoice["Sub Total"] = data.SubTotal
                    invoice["Total Tax"] = data.TotalTax
                    invoice["Discount"] = data.DiscountAmount
                    invoice["Grand Total"] = data.Amount

                    invoices.push(invoice);
                })
                const csvData = constatnts.objToCSV(invoices);
                this.setState({ loading: false, exportCalled: false })
                const csvBlob = new Blob([csvData], { type: "text/csv" });
                const url = window.URL.createObjectURL(csvBlob);
                const a = document.createElement("a");
                a.setAttribute("hidden", "");
                a.setAttribute("href", url);
                a.setAttribute("download", "GST Report.csv");
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            })
    }

    onSearchClick() {
        this.setState({ searchFrom: 0, loading: true })
        this.loadInvoiceDetailReport(
            this.state.storeList,
            0,
            this.state.searchTransactionNo,
            this.state.searchTransactiontype,

            this.state.searchTransactionFromDate, this.state.searchTransactionToDate,
            this.state.searchCustomerDetail,
            this.state.searchProductDetail,
            this.state.searchDiscount,
            this.state.searchTaxableAmount,
            this.state.searchTaxSummary
        )
    }

    onStoreChange(e){
        let storeList = []
        console.log("key", e.target.value);
        if (e.target.value != "") {
            storeList.push({key: e.target.value})
        }
        else
        {
            for (let i = 0; i < this.state.stores.length; i++) {
                const store = this.state.stores[i];
                storeList.push({ key: store.key })
            }
        }
        console.log("storeList", JSON.stringify(storeList));
        this.setState({ storeList: storeList, storeID: e.target.value })
    }

    render() {

        return <div className="content-wrapper" >
            <section className="content" >
                <div className="row">
                    <div className="col-md-12">
                        <div className="box ">
                            <div className="box-header with-border">
                                <div className="row">
                                    <div className="col-md-6">
                                        <font style={{ fontSize: "30px" }}>GSTR 1 Report</font>
                                    </div>
                                    <div className="col-md-6">
                                        <button type="cancel" className="btn btn-default pull-right btn-flat"
                                            style={{ marginTop: "5px", marginLeft: "10px" }}
                                            onClick={() => this.props.history.push({ pathname: "/home/reports/allreport" })}
                                        ><i className="fa fa-arrow-left"></i> Back</button>
                                    </div>
                                </div>
                            </div>
                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <label>Store Name</label>
                                        <select className="form-control"
                                            value={this.state.storeID}
                                            onChange={this.onStoreChange}>
                                            <option value="">All Stores</option>
                                            {this.state.stores.filter((e) => !e.IsDeleted).map((store) =>
                                                <option value={store.key}>{store.StoreCode}-{store.StoreName}</option>
                                            )}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Transaction No</label>
                                            <input type="text" className="form-control"
                                                onChange={(evt) => this.setState({ searchTransactionNo: evt.target.value })}
                                                value={this.state.searchTransactionNo}
                                                onKeyPress={this.handleKeyPress} />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Transaction Type</label>
                                            <select type="text" className="form-control"
                                                onChange={(evt) => this.setState({ searchTransactiontype: evt.target.value })}
                                            >
                                                <option value="">All</option>
                                                {this.props.config.TransactionTypes.filter((e) => e.Module === "sales" && !e.IsDeleted).map((e) => <option value={e.key}>{e.TransactionType}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="row">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>Transaction From</label>
                                            <input type="date" className="form-control"
                                                onChange={(evt) => this.setState({ searchTransactionFromDate: evt.target.value })}
                                                value={this.state.searchTransactionFromDate}
                                                onKeyPress={this.handleKeyPress} />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label>Transaction To</label>
                                            <input type="date" className="form-control"
                                                onChange={(evt) => this.setState({ searchTransactionToDate: evt.target.value })}
                                                value={this.state.searchTransactionToDate}
                                                onKeyPress={this.handleKeyPress} />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Customer Name,Code,Phone Number,Email</label>
                                            <input type="text" className="form-control"
                                                onChange={(evt) => this.setState({ searchCustomerDetail: evt.target.value })}
                                                value={this.state.searchCustomerDetail}
                                                onKeyPress={this.handleKeyPress} />
                                        </div>
                                    </div>


                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Product Name,Code,</label>
                                            <input type="text" className="form-control"
                                                onChange={(evt) => this.setState({ searchProductDetail: evt.target.value })}
                                                value={this.state.searchProductDetail}
                                                onKeyPress={this.handleKeyPress} />
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className="row" >
                                    <div className="col-md-12" style={{ marginTop: "-25px" }}>
                                        <button type="button" className="btn btn-primary btn-flat btn-md pull-right"
                                            style={{ marginTop: "25px", marginLeft: "5px" }}
                                            onClick={this.onSearchClick}
                                        >Search</button>
                                        <button type="button" className="btn btn-default btn-flat btn-md pull-right" style={{ marginTop: "25px" }}
                                            onClick={this.onClearSearch} >Clear</button>
                                        <button class="btn btn-default btn-flat btn-md pull-right"
                                            style={{ marginTop: "25px", marginRight: "5px" }}
                                            onClick={this.onExportClick}
                                        > Export <i class="glyphicon glyphicon-download-alt " ></i></button>
                                    </div>
                                </div><br></br>
                                {this.state.loading && <Loader show={this.state.loading} />}
                                {!this.state.loading &&
                                    <div style={{width:"auto", overflowX:"auto"}} className="scroll2">
                                        {ReactHtmlParser(this.state.invoices)}
                                    </div> 
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    }
}

export default withRouter(InvoiceDetailList1)